import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Image as ImageIcon, Sparkles, Search, Upload } from 'lucide-react';

// 1. The React Component that renders INSIDE the editor canvas
const AssetPlaceholderComponent = (props) => {
    // getPos gives us the exact coordinates of this widget in the document
    const { node, editor, getPos } = props; 
    const prompt = node.attrs.prompt || '';

    // We dispatch a custom event to tell the main Editor to open the modals
    const handleAction = (actionType) => {
        const event = new CustomEvent('trigger-asset-action', {
            detail: { actionType, prompt, pos: getPos() }
        });
        window.dispatchEvent(event);
    };

    return (
        <NodeViewWrapper className="asset-placeholder-node my-4" contentEditable={false}>
            <div className="p-4 border border-primary border-dashed rounded bg-light text-center shadow-sm">
                <h6 className="text-primary fw-bold mb-3 d-flex align-items-center justify-content-center gap-2">
                    <ImageIcon size={20} /> Missing Asset Needed
                </h6>
                
                <p className="text-muted fst-italic mb-4" style={{ fontSize: '1.1rem' }}>
                    "{prompt}"
                </p>

                <div className="d-flex justify-content-center gap-3">
                    <Button variant="outline-secondary" size="md" onClick={() => handleAction('upload')}>
                        <Upload size={18} className="me-1" /> Local Upload
                    </Button>
                    <Button variant="outline-primary" size="md" onClick={() => handleAction('unsplash')}>
                        <Search size={18} className="me-1" /> Search Unsplash
                    </Button>
                    <Button variant="success" size="md" onClick={() => handleAction('ai')} className="fw-bold">
                        <Sparkles size={18} className="me-1" /> Generate via AI
                    </Button>
                </div>
            </div>
        </NodeViewWrapper>
    );
};

// 2. The TipTap Extension Definition
export default Node.create({
    name: 'assetPlaceholder',
    group: 'block',
    atom: true, // Prevents users from typing inside the widget

    addAttributes() {
        return {
            prompt: { default: '' },
        };
    },

    parseHTML() {
        return [
            { tag: 'div[data-type="asset-placeholder"]' },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'asset-placeholder' })];
    },

    addNodeView() {
        return ReactNodeViewRenderer(AssetPlaceholderComponent);
    },
});